import React from 'react'
import LaoPlanningChart from 'components/LAO/LaoPlanningChart'
import LaoPlanningDetails from 'components/LAO/LaoPlanningDetails'

const LaoExportPlanning = () => {
  return (
    <div>
      <LaoPlanningChart />
      <LaoPlanningDetails />
    </div>
  )
}

export default LaoExportPlanning